module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "shopperApprovalModal",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.SAM000))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v(_vm._s(_vm.lang.SAM001))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM002) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM003) + "\n                ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.SAM004) + "\n                ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.check.ShopperProposals), function(proposal, index) {
    return _c('tr', {
      key: proposal.ShopperProposalGuid,
      attrs: {
        "proposal": proposal
      }
    }, [_c('td', {
      staticClass: "text-left",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "info-btns"
    }, [(proposal.UpdateShopperProposal) ? [_c('button', {
      staticClass: "btn nopadding",
      staticStyle: {
        "border-radius": "50%"
      },
      attrs: {
        "id": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid))
      },
      on: {
        "click": function($event) {
          return _vm.updateShopperData(proposal)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("refresh")])]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("updateShopperDataButton-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_vm._v(_vm._s(_vm.lang.SPM020))])] : _vm._e(), _vm._v(" "), (proposal.ShopperPreviousVisited) ? [_c('i', {
      staticClass: "material-icons md-24",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      attrs: {
        "id": ("ShopperPreviousVisited-" + (proposal.ShopperProposalGuid))
      }
    }, [_vm._v("info_outline")]), _vm._v(" "), _c('b-tooltip', {
      ref: "tooltip",
      refInFor: true,
      attrs: {
        "target": ("ShopperPreviousVisited-" + (proposal.ShopperProposalGuid)),
        "delay": _vm.globals.tooltipDelay
      }
    }, [_c('div', {
      staticClass: "survey-id-info-tooltip"
    }, [_vm._v("\n                          " + _vm._s(_vm.lang.SAM028) + "\n                          "), _c('br')])])] : _vm._e()], 2), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM005) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperId))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM006) + " (" + _vm._s(_vm.lang.SAM007) + "):\n                    "), _c('b', [_vm._v(_vm._s(proposal.DisplayName))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM008) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Gender))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM009) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Distance) + " km")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (proposal.Profession),
        expression: "proposal.Profession"
      }]
    }, [_vm._v("\n                    " + _vm._s(_vm.lang.SAM010) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.Profession))])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM012) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.CarSegmentName))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "baseline"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.lang.SAM011) + ":\n                    "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.CarModelGuid),
        expression: "proposal.CarModelGuid"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "newShopperProposalCarModelSelect",
        "disabled": !proposal.CarSegmentGuid
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "CarModelGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          proposal.CompetitorCarModelGuid = '';
          _vm.updateShopperProposalCarModelAndMatch(proposal)
        }]
      }
    }, _vm._l((_vm.carModelsOfSelectedSegment(proposal.CarSegmentGuid)), function(model) {
      return _c('option', {
        key: model.CarModelGuid,
        domProps: {
          "value": model.CarModelGuid
        }
      }, [_vm._v("\n                        " + _vm._s(model.CarModelName) + "\n                      ")])
    }), 0)]), _vm._v(" "), (_vm.check.CompetitorCarModelDistribution) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "baseline"
      }
    }, [_c('span', {
      staticStyle: {
        "text-wrap": "nowrap"
      }
    }, [_vm._v(_vm._s(_vm.lang.SAM030))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.CompetitorCarModelGuid),
        expression: "proposal.CompetitorCarModelGuid"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "newShopperProposalCompetitorCarModelSelect",
        "disabled": !proposal.CarSegmentGuid
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "CompetitorCarModelGuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          proposal.CarModelGuid = '';
          _vm.updateShopperProposalCarModelAndMatch(proposal)
        }]
      }
    }, _vm._l((_vm.check.CompetitorCarModelDistribution), function(model) {
      return _c('option', {
        key: model.CompetitorCarModelGuid,
        domProps: {
          "value": model.CompetitorCarModelGuid
        }
      }, [_vm._v("\n                      " + _vm._s(model.CompetitorCarBrand) + " " + _vm._s(model.CompetitorCarModel) + "\n                      ")])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM013) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.ShopperCar))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "baseline"
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.lang.SAM014) + ":")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.CarMatch),
        expression: "proposal.CarMatch"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "newShopperProposalCarMatchSelect"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "CarMatch", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateShopperProposalCarModelAndMatch(proposal)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "+"
      }
    }, [_vm._v("+ " + _vm._s(_vm.lang.SAM017))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "="
      }
    }, [_vm._v("= " + _vm._s(_vm.lang.SAM016))]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "-"
      }
    }, [_vm._v("- " + _vm._s(_vm.lang.SAM015))])])]), _vm._v(" "), _c('div', [_vm._v("\n                    " + _vm._s(_vm.lang.SAM018) + ":\n                    "), _c('b', [_vm._v(_vm._s(proposal.LastUpdatedAt))])])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [(_vm.globals.isLeadAgencyUser || _vm.globals.isAdminUser) ? _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Agency')
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.lang.SAM019) + "\n                      "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), (proposal.LastCommentLeadLocal) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadLocalCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(proposal.LastCommentLeadLocal, 120)) + "\n                    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "comment-type-container"
    }, [_c('a', {
      staticClass: "comment-type-header",
      on: {
        "click": function($event) {
          return _vm.showFeed(proposal, 'Audi')
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.globals.isAudiUser ? _vm.lang.SAM021 : _vm.lang.SAM020) + "\n                      "), _c('i', {
      staticClass: "material-icons md-24"
    }, [_vm._v("forum")])]), _vm._v(" "), (proposal.LastCommentLeadAudi) ? _c('div', {
      staticClass: "last-comment-container"
    }, [_c('b', [_vm._v(_vm._s(proposal.LastCommentLeadAudiCreatedBy) + ":")]), _vm._v("\n                      " + _vm._s(_vm.globals.truncateString(proposal.LastCommentLeadAudi, 120)) + "\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('td', [(!(_vm.globals.isLeadAgencyUser && _vm.userAgencyEqualsCheckAgency)) ? _c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.AgencyApprovalStatus),
        expression: "proposal.AgencyApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.AgencyApprovalStatus === 'Approved',
        'option-red': proposal.AgencyApprovalStatus === 'Rejected',
        'option-yellow': !proposal.AgencyApprovalStatus,
      },
      attrs: {
        "disabled": (!_vm.globals.isAudiUser && proposal.MainEntityApprovalStatus) || _vm.check.SurveyInstanceStatusId > 200
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "AgencyApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'leadAgency')
        }]
      }
    }, [_c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])]) : _vm._e()]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "form-group"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (proposal.MainEntityApprovalStatus),
        expression: "proposal.MainEntityApprovalStatus"
      }],
      staticClass: "form-control",
      class: {
        'option-green': proposal.MainEntityApprovalStatus === 'Approved',
        'option-red': proposal.MainEntityApprovalStatus === 'Rejected',
        'option-yellow': !proposal.MainEntityApprovalStatus,
      },
      attrs: {
        "disabled": !(_vm.globals.isAdminUser || _vm.globals.isAudiUser || (_vm.globals.isLeadAgencyUser && _vm.userAgencyEqualsCheckAgency)) || _vm.check.SurveyInstanceStatusId > 200
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(proposal, "MainEntityApprovalStatus", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateApprovalState(proposal, 'mainEntity')
        }]
      }
    }, [(!_vm.anyShopperAlreadyApproved || proposal.MainEntityApprovalStatus === 'Approved') ? _c('option', {
      staticClass: "option-green",
      domProps: {
        "value": 'Approved'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM022) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('option', {
      staticClass: "option-yellow",
      domProps: {
        "value": undefined
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM023) + "\n                      ")]), _vm._v(" "), _c('option', {
      staticClass: "option-red",
      domProps: {
        "value": 'Rejected'
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.lang.SAM024) + "\n                      ")])])])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('table', {
    staticClass: "table outer-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.statusData.CarDistribution && _vm.check.Brand === 'Audi') ? _c('tr', [_c('td', {
    staticClass: "text-left"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.AWS029))])]), _vm._v(" "), _c('td', {
    staticClass: "text-left"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.statusData.CarDistribution), function(model, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(model.CarModelName))]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                        ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.statusData.CompetitorCarDistribution && _vm.check.Brand !== 'Audi') ? _vm._l((_vm.getGroupedCompetitorCars()), function(competitorCarDistribution, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('b', [_vm._v(_vm._s(competitorCarDistribution[0]) + " " + _vm._s(_vm.lang.AWS033))])]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_c('table', {
      staticClass: "table table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.lang.AWS030))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS031))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS032))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS026))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS028))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.lang.AWS027))])])]), _vm._v(" "), _c('tbody', _vm._l((competitorCarDistribution[1]), function(model, index) {
      return _c('tr', {
        key: index
      }, [_c('td', [_vm._v(_vm._s(model.CompetitorCarModel))]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.SetValue * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ActualValue * 100).toFixed(2))) + " % (" + _vm._s(model.ApprovedCarCount) + ")\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountDowngrade_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountMatch_percentage * 100).toFixed(2))) + " %\n                          ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(Number((model.ApprovedCarCountUpgrade_percentage * 100).toFixed(2))) + " %\n                          ")])])
    }), 0)])])])
  }) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.lang.SAM025) + "\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding noborder",
    staticStyle: {
      "width": "70%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d82dd8ec","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopperApproval/ShopperApprovalModal.vue
// module id = 1729
// module chunks = 1